// IMPORTANT: Do not remove the React import. Required for JSX transformation and component rendering.
import React from "react";
import styled from "styled-components";

type LoginButtonProps = {
  text: string;
  icon: string;
  onClick?: () => void;
};

const StyledLoginButton = styled.button`
  cursor: pointer;
  width: 95%;
  height: 40px;
  padding: 0px 15px;
  border-radius: 20px;
  border: 1px solid #ccc;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: normal;
  text-align: center;
  position: relative;
  transition: background-color 0.1s ease;
  &:hover {
    background-color: #ececec;
  }
  @media (max-width: 267px) {
    line-height: 1.2;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  z-index: 2;
`;

const TextWrapper = styled.span`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const LoginButton = ({ text, icon, onClick }: LoginButtonProps) => {
  return (
    <StyledLoginButton onClick={onClick}>
      <IconWrapper>
        <img src={icon} style={{ width: 20, height: 20, flexShrink: 0 }} alt="" />
      </IconWrapper>
      <TextWrapper>{text}</TextWrapper>
    </StyledLoginButton>
  );
};

export default LoginButton;
